import { render, staticRenderFns } from "./ArtQuiz.vue?vue&type=template&id=a11d5192&scoped=true"
import script from "./ArtQuiz.vue?vue&type=script&lang=js"
export * from "./ArtQuiz.vue?vue&type=script&lang=js"
import style0 from "./ArtQuiz.vue?vue&type=style&index=0&id=a11d5192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11d5192",
  null
  
)

export default component.exports